/**
 * SharePage - Sistema de partilha de páginas
 * 
 * Como usar:
 * 1. Adicione a classe ".imageShare-page" à imagem ou div que quer usar nas partilhas
 * 
 * Exemplos:
 * - <img class="imageShare-page" src="imagem.jpg" />
 * - <div class="imageShare-page" style="background-image: url('imagem.jpg')"></div>
 * 
 * Se não encontrar .imageShare-page, usa og:image dos metadados
 */

class SharePage {
  constructor() {
    this.shareBtn = document.getElementById('share-toggle');
    this.shareOptions = document.getElementById('share-options');
    this.copyLinkBtn = document.getElementById('copy-link');

    if (!this.shareBtn || !this.shareOptions) return;

    console.log('SharePage inicializado');
    this.init();
  }

  init() {
    // Toggle do menu de compartilhamento
    this.shareBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log('Share button clicked');
      this.shareOptions.classList.toggle('active');
    });

    // Fechar menu quando clicar fora
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.share-page')) {
        this.shareOptions.classList.remove('active');
      }
    });

    // Copiar link para clipboard
    if (this.copyLinkBtn) {
      this.copyLinkBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.copyToClipboard();
      });
    }

    // Adicionar listeners aos botões de share
    this.setupShareLinks();
  }

  setupShareLinks() {
    const pageUrl = window.location.href;
    const pageTitle = document.title || 'Confira isto';
    
    // Procurar pela imagem de compartilhamento customizada
    let shareImageUrl = '';
    const shareImageElement = document.querySelector('.imageShare-page');
    
    if (shareImageElement) {
      // Se for uma tag <img>
      if (shareImageElement.tagName === 'IMG') {
        shareImageUrl = shareImageElement.src;
      } 
      // Se for um div com background-image
      else {
        const bgImage = window.getComputedStyle(shareImageElement).backgroundImage;
        if (bgImage && bgImage !== 'none') {
          shareImageUrl = bgImage.replace(/url\(['"]?([^'")]+)['"]?\)/g, '$1');
        }
      }
    }
    
    // Se não encontrar imagem customizada, usar og:image
    const ogImage = shareImageUrl || document.querySelector('meta[property="og:image"]')?.getAttribute('content') || '';
    const ogDescription = document.querySelector('meta[property="og:description"]')?.getAttribute('content') || 
                         document.querySelector('meta[name="description"]')?.getAttribute('content') || pageTitle;

    console.log('Share Image URL:', ogImage);

    const shareLinks = document.querySelectorAll('.share-option');
    
    shareLinks.forEach((link) => {
      const text = link.textContent.trim();
      
      // Prevenir comportamento padrão
      if (link.tagName === 'A') {
        link.href = '#';
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      // Configurar cada rede social
      if (text === 'Facebook') {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openShareWindow(fbUrl, 'Facebook');
        });
      } 
      else if (text === 'Twitter') {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(pageTitle)}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openShareWindow(twitterUrl, 'Twitter');
        });
      } 
      else if (text === 'LinkedIn') {
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openShareWindow(linkedinUrl, 'LinkedIn');
        });
      } 
      else if (text === 'WhatsApp') {
        const whatsappText = `${pageTitle} ${pageUrl}`;
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappText)}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(whatsappUrl, '_blank');
        });
      } 
      else if (text === 'Pinterest') {
        const pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&description=${encodeURIComponent(pageTitle)}${ogImage ? `&media=${encodeURIComponent(ogImage)}` : ''}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openShareWindow(pinterestUrl, 'Pinterest');
        });
      } 
      else if (text === 'Email') {
        const emailSubject = `Confira: ${pageTitle}`;
        const emailBody = `${ogDescription}\n\n${pageUrl}`;
        const emailUrl = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
        link.href = emailUrl;
        link.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    });
  }

  openShareWindow(url, platform) {
    const width = 600;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    window.open(
      url,
      `share-${platform}`,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );
  }

  copyToClipboard() {
    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        const originalText = this.copyLinkBtn.textContent;
        this.copyLinkBtn.textContent = 'Link copiado!';
        setTimeout(() => {
          this.copyLinkBtn.textContent = originalText;
        }, 2000);
      })
      .catch(err => {
        console.error('Erro ao copiar:', err);
        alert('Erro ao copiar o link');
      });
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded, iniciando SharePage');
    new SharePage();
  });
} else {
  console.log('DOM já pronto, iniciando SharePage');
  new SharePage();
}
